import http from '@/support/services/HttpService';
import CrudRequest from '../CrudRequest';

class CustomerRequest extends CrudRequest {
  static baseUrl() {
    return '/v1/clientes';
  }

  static blockOrActive(clienteId, payload) {
    return http.patch(`${this.baseUrl()}/${clienteId}/alterarStatus`, payload);
  }

  static manuallyTerminateList(query = {}) {
    return http.get(`${this.baseUrl()}/relatorioDeClientes`, {
      params: query,
    });
  }

  static terminate(params = {}) {
    return http.get(`${this.baseUrl()}/relatorioDeClientes/agendar`, {
      params,
    });
  }

  static configContratacoes(id, payload) {
    return http.put(
      `${this.baseUrl()}/${id}/configurarContratacoes`,
      payload,
    );
  }
}

export default CustomerRequest;
